/* eslint-disable no-console */
type LoggerMessageType = 'info' | 'error' | 'success';

type LoggerItemType = {
  type?: LoggerMessageType;
  message: any;
  items?: LoggerItemType[];
};

const LOGGER_ITEM_TYPE_COLORS_MAP: Record<LoggerMessageType, string> = {
  info: 'color: white; background-color: #2274A5',
  success: 'color: white; background-color: #95B46A',
  error: 'color: white; background-color: #D33F49',
};

class Logger {
  _space: string;

  constructor(space: string) {
    this._space = space;
  }

  private displayLogs = (items: LoggerItemType[]) => {
    items.forEach(({ type, message, items }) => {
      const isExistItems = !!items;
      const resolvedMessage = type
        ? [`%c ${message} `, LOGGER_ITEM_TYPE_COLORS_MAP[type]]
        : [message];
      if (isExistItems) {
        console.group(...resolvedMessage);
        this.displayLogs(items);
        console.groupEnd();
      } else {
        console.log(...resolvedMessage);
      }
    });
  };

  log = (items: LoggerItemType[]) => {
    const isProd = process.env.IS_PRODUCTION;

    if (!isProd) {
      console.group(this._space);
      this.displayLogs(items);
      console.groupEnd();
    }
  };
}

export default new Logger('Perxis Auto Instock');
